module.exports = __webpack_public_path__ + "e4b71ad705bc6af66538e7e3e9cd03b5.svg";